<template>
	<el-card>
		<div style="margin-bottom: 20px">
			<el-select v-model="status" multiple placeholder="全部状态" @change="selectstatus">
				<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"> </el-option>
			</el-select>
		</div>

		<div class="table">
			<el-table
				:data="tableData"
				style="width: 100%"
				:header-cell-style="{ background: '#eef1f6' }"
				@sort-change="sortchange"
				v-loading="loading"
			>
				<el-table-column prop="productName" label="购买商品名称"> </el-table-column>
				<el-table-column align="center" prop="orderNo" width="200px" label="订单号"> </el-table-column>
				<!-- <el-table-column prop="thirdNo" width="300px" label="付款流水"> </el-table-column> -->
				<el-table-column align="center">
					<template #header>
						<div>
							<span class="condition">状态</span>
						</div>
					</template>
					<template slot-scope="scope">
						<span class="status notstart" v-if="scope.row.statusText === '未开始'"></span>
						<span class="status executed" v-if="scope.row.statusText === '已生效'"></span>
						<span class="status effect" v-if="scope.row.statusText === '部分生效'"></span>
						<span class="status failed" v-if="scope.row.statusText === '已失效'"></span>
						<span class="statusText"> {{ scope.row.statusText }}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="payed_at" sortable label="付款时间"> </el-table-column>
				<el-table-column align="center" width="80px" label="操作">
					<template slot-scope="scope">
						<el-link type="primary" @click="examine(scope.row)">查看</el-link>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="toolbar large-list">
			<div class="pagination-group">
				<el-pagination
					:background="true"
					:page-sizes="[30, 50, 100]"
					:page-size.sync="pageSize"
					:current-page.sync="page"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
					@size-change="reqOrder"
					@current-change="reqOrder"
				/>
			</div>
		</div>
	</el-card>
</template>

<script>
import { Order } from '@/utils/api'
export default {
	data() {
		return {
			loading: false,
			tableData: [],
			pageSize: 30,
			page: 1,
			total: 0,
			direction: null,
			options: [
				{ id: 1, name: '未开始' },
				{ id: 2, name: '已失效' },
				{ id: 3, name: '已生效' },
				{ id: 4, name: '部分生效' },
			],
			status: [],
		}
	},
	mounted() {
		this.reqOrder()
	},
	methods: {
		//状态筛选
		selectstatus() {
			this.reqOrder()
		},
		reqOrder() {
			this.loading = true
			let params = {
				orderBy: 'payed_at',
				direction: this.direction,
				page: this.page,
				perPage: this.pageSize,
				status: JSON.stringify(this.status),
				source: JSON.parse(sessionStorage.getItem('sourceInfo')).sourceId,
			}
			Order(params)
				.then((res) => {
					if (!res) {
						this.loading = false
						return
					}
					this.loading = false
					this.total = res.total
					this.tableData = res.data
				})
				.catch(() => {
					this.loading = false
				})
		},
		//数据详情
		examine(row) {
			this.$router.push({
				path: 'orderDetail',
				query: {
					orderNo: row.orderNo,
				},
			})
		},
		//时间排序
		sortchange(row) {
			if (row.order === 'descending') {
				this.direction = 0
			} else if (row.order === 'ascending') {
				this.direction = 1
			} else {
				this.direction = null
			}
			this.reqOrder()
		},
	},
}
</script>

<style scoped>
.order-title {
	font-size: 20px;
	font-weight: bold;
	text-align: center;
	margin: 20px 0;
}
.box-card {
	width: 80%;
	margin: 0 10%;
}
.table {
	padding-bottom: 60px;
}
.el-table__header-wrapper {
	height: 30px;
}
.condition {
	font-weight: bold;
}
.condition_i {
	vertical-align: middle;
	width: 16px;
	display: inline-block;
	cursor: pointer;
}
.toolbar {
	text-align: right;
	padding: 10px 10%;
	height: 32px;
	width: 80%;
	background-color: #fff;
}
.large-list {
	position: fixed;
	right: 37px;
	bottom: 0;
}
.status {
	width: 5px;
	height: 5px;
	border-radius: 50%;
	display: inline-block;
	vertical-align: middle;
	margin-right: 2px;
}
.notstart {
	background-color: #ccc;
}
.executed {
	background-color: #52c41a;
}
.effect {
	background-color: #1890ff;
}
.failed {
	background-color: #ff4d4f;
}
.statusText {
	vertical-align: middle;
}
</style>
